import * as React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import { DynamicForm, WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
import { createInitialFormValues } from '../../../components/FormComponents/dynamicForm/form_validation';
import { buildNewLocationSections, readNewLocationValues, } from '../config/create_application_schema';
var AddNewLocationDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSave = _a.onSave;
    var formRef = React.useRef(null);
    var sections = React.useMemo(function () { return buildNewLocationSections(); }, []);
    var initialValues = React.useMemo(function () { return createInitialFormValues(sections); }, [sections]);
    React.useEffect(function () {
        var _a;
        if (open) {
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        }
    }, [open]);
    var handleSave = React.useCallback(function () {
        var _a;
        if (!((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.validate())) {
            return;
        }
        onSave(readNewLocationValues(formRef.current.getValues()));
    }, [onSave]);
    return (React.createElement(Dialog, { open: open, onClose: onClose, fullWidth: true, maxWidth: "sm", "aria-labelledby": "add-new-location-title", disableEnforceFocus: true, PaperProps: { sx: { borderRadius: '12px' } } },
        React.createElement(DialogTitle, { id: "add-new-location-title", sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: 16,
                fontWeight: 600,
                color: WIZARD_COLORS.ink,
            } },
            "Add a New Location",
            React.createElement(IconButton, { "aria-label": "Close", onClick: onClose, size: "small" },
                React.createElement(CloseIcon, { fontSize: "small" }))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(DynamicForm, { ref: formRef, sections: sections, initialValues: initialValues }),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mt: 1.5,
                    px: 1.5,
                    py: 1,
                    bgcolor: '#EAF1F8',
                    borderRadius: '10px',
                } },
                React.createElement(InfoOutlinedIcon, { sx: { fontSize: 20, color: '#2E75B6', flexShrink: 0 } }),
                React.createElement(Typography, { sx: { fontSize: 13, color: '#2E75B6', lineHeight: 1.3 } }, "Start typing the address to pick a verified one, or enter it by hand."))),
        React.createElement(Stack, { direction: "row", justifyContent: "flex-end", gap: 1.5, sx: { p: 2 } },
            React.createElement(CustomButton, { variant: "secondary", MDButton: true, fullWidth: false, onClick: onClose }, "Cancel"),
            React.createElement(CustomButton, { variant: "contained", MDButton: true, fullWidth: false, bgColor: WIZARD_COLORS.ink, onClick: handleSave }, "Save"))));
};
export default React.memo(AddNewLocationDialog);
